
import * as bootstrap from 'bootstrap';
import $ from 'jquery';
import 'jquery-mask-plugin';


import '../styles/main.scss';
import './leadform';
import './header';
import './community';
import './coach';
import './who';
import './music';
